// extracted by mini-css-extract-plugin
module.exports = {"startAdornment":"select_startAdornment__3BVFS","option":"select_option__38Ulf"};